import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import {fetch} from 'services/CustomersService';

import {schema} from 'normalizr';

const entityKey = 'customers';


export const entitySchema = new schema.Entity(entityKey);
export const arrayOfRecords = new schema.Array(entitySchema);

const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
};

// genenrates pending, fulfilled and rejected
export const fetchCustomer = createAsyncThunk(`${entityKey}/fetch`, (id) => {
    return fetch(id).then((response) => response);
});

const customersSlice = createSlice({
                                       name: entityKey,
                                       initialState,
                                       extraReducers: (builder) => {
                                           // FETCH ONE
                                           builder.addCase(fetchCustomer.pending, (state) => {
                                               state.loading = true;
                                           });

                                           builder.addCase(fetchCustomer.fulfilled, (state, action) => {
                                               state.byId[action.payload.id] = action.payload;
                                               state.loading = false;
                                           });

                                           builder.addCase(fetchCustomer.rejected, (state, action) => {
                                               state.loading = false;
                                               state.error = action.error.message;
                                           });
                                       },
                                   });

export default customersSlice.reducer;
